export default "__VITE_ASSET__D7C6At9o__"